var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.entry)?_c('p',{staticClass:"is-font-extra-large is-font-bold mb-1"},[_vm._v(" "+_vm._s(_vm.entry.attributes.title)+" ")]):_c('div',{staticClass:"skeleton skeleton-title"})
}
var staticRenderFns = []

export { render, staticRenderFns }